
const RectangleSVG = () => {
    return ( 
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.95 146.99" className = "absolute slate w-2/5 z-10 opacity-30">
            <defs>
                <linearGradient id="a" x1="-16.51" x2="97.46" y1="130.48" y2="16.51" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#ff77fc"/>
                <stop offset=".49" stopColor="#ff9ba8"/>
                <stop offset="1" stopColor="#ffc053"/>
                </linearGradient>
            </defs>
            <path fill="url(#a)" d="M0 0h80.95v146.99H0z"/>
        </svg>
    )
}
export default RectangleSVG;